export class GeneralUtils {

  /**
   * Ordenar listado
   *
   */
  public static orderBy(array: any[], keys: string[], direction: 'asc' | 'desc' = 'desc'): any[] {

    const factor: number = direction === 'asc' ? 1 : -1;

    return array.slice().sort((a, b) =>

      keys.reduce((result: number, key: string) => {

        if (result !== 0) {
          return result;
        }

        const valueA = GeneralUtils.getValue(a, key);
        const valueB = GeneralUtils.getValue(b, key);

        if (valueA > valueB) {
          return factor;
        }

        if (valueA < valueB) {
          return -1 * factor;
        }

        return 0;
      }, 0)
    );
  }


  /**
   * Obtiene los valores de las propiedades
   *
   */
  private static getValue(obj: any, key: string): any {
    return key.split('.').reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), obj);
  }

}
